import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import classNames from "classnames";

import LanguageFlag from "../../components/LanguageFlag/LanguageFlag";

import { getTenantInfo } from "../../reducers/tenant";
import { getCurrentTrader } from "../../reducers/trader";
import { SplitButton } from "primereact/splitbutton";

import {
  clearCart,
  clearOnHome,
  clearOnLogout,
  clearSO,
} from "../../actions/dispatch/dispatchCommon";
import history from "../../helper/history";

import { APP_LOADING_STATUS, COMMON_STATUS } from "../../constants/status";
import { Button } from "primereact/button";
import {
  getChangedOrder,
  getItemRemovedList,
  getStandingOrderAddedList,
  newChangedOrder,
  newRemovedItemList,
  removeAddedItemToSOList,
} from "../../reducers/standingOrder";
import { getTenantName } from "../../reducers/app";
import { reloadTrader } from "../../reducers/traders";
import { getLiveAddresses } from "../../reducers/address";

type Props = {
  showCustomers: boolean | null;
  setToken: any;
  clientName: string | null;
  clientFullName: string | null;
  setAppLoadingStatus: any;
  onSetLanguage: (lang: string) => void;
  currentlang: string;
  logout: () => void;
};

const AppTopbar: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const {
    currentlang,
    showCustomers,
    setToken,
    setAppLoadingStatus,
    onSetLanguage,
    logout,
  } = props;
  const client_info = useSelector(getTenantInfo);
  const client_name = useSelector(getTenantName);
  const liveAddresses = useSelector(getLiveAddresses);

  // For Standing Order Page
  const addedItemList_store = useSelector(getStandingOrderAddedList);
  const itemRemovedList = useSelector(getItemRemovedList);
  const changedOrderList = useSelector(getChangedOrder);

  const [show_customers, setShowCustomers] = useState<boolean | null>(null);
  const [client_name_css, setClientNameCss] = useState("tenant-name");

  const current_customer = useSelector(getCurrentTrader);

  useEffect(() => {
    setShowCustomers(showCustomers);
  }, [showCustomers]);



  useEffect(() => {
    if (show_customers === false) {
      setClientNameCss("tenant-name-solo ml-2");
    } else {
      setClientNameCss("tenant-name ml-2");
    }
  }, [show_customers]);

  // const logout = () => {
  //     clearOnLogout(dispatch);
  //     setToken(null);
  //     setAppLoadingStatus(APP_LOADING_STATUS.CLIENT_DONE)
  //     setTimeout(() => { history.push(`${process.env.PUBLIC_URL}/${props.clientName}/login`) }, 200);
  // }

  const goToHome = () => {
    if (
      addedItemList_store.length > 0 ||
      itemRemovedList.length > 1 ||
      changedOrderList.length > 0
    ) {
      const confirmNavigation = window.confirm(
        "You have unsaved changes. Are you sure you want to leave?"
      );

      if (!confirmNavigation) {
        return; // Stop navigation if the user cancels
      }

      if (confirmNavigation) {
        dispatch(removeAddedItemToSOList([]));
        dispatch(newChangedOrder([]));
        dispatch(newRemovedItemList([{ itemId: -1, newItem: false }]));
      }
    }

    clearOnHome(dispatch);

    setTimeout(() => {
      history.push(`${process.env.PUBLIC_URL}/${props.clientName}`);
    }, 200);
  };

  const gotoMain = () => {

    const currentDefaultPage = (sessionStorage.getItem('page') && sessionStorage.getItem('page') == 'cartDefault')

    if (!currentDefaultPage) {
      clearCart(dispatch);
      clearSO(dispatch);
    }


    if (show_customers)
      if (!currentDefaultPage) {
        setTimeout(() => {
          history.push(`${process.env.PUBLIC_URL}/${props.clientName}/set`);
        }, 200);
      }
      else
        if (!currentDefaultPage) {
          setTimeout(() => {
            history.push(`${process.env.PUBLIC_URL}/${props.clientName}`);
          }, 200);
        }
  };

  const setLanguage = (lang: string) => {
    onSetLanguage(lang);
  };

  const showFeedback = () => {
    const iframe = document.getElementById("jsd-widget");
    if (iframe instanceof HTMLIFrameElement && iframe.contentWindow) {
      const helpButton =
        iframe.contentWindow.document.getElementById("help-button");
      if (helpButton) {
        helpButton.click();
      }
    }
  };

  const items = current_customer?.live == 1 && (liveAddresses?.length??0) >0 ? [
    {
      label: "Cart",
      icon: "pi pi-shopping-cart",
      command: () => {
        history.push({
          pathname: `${process.env.PUBLIC_URL}/${client_name}/set`,
        });
      },
    },
    {
      label: "Standing Order",
      icon: "pi pi-list",
      command: () => {
        history.push({
          pathname: `${process.env.PUBLIC_URL}/${client_name}/standingorder/${current_customer?.id}`,
        });
      },
    },
    {
      label: "--------------------------",
      // icon: "pi pi-comments",
      disabled: true,
    },
    {
      label: "Feedback",
      icon: "pi pi-comments",
      command: showFeedback,
    },
  ] :
    [
      {
        label: "Feedback",
        icon: "pi pi-comments",
        command: showFeedback,
      },
    ];

  return (
    <div className="layout-topbar">
      <div className="layout-topbar-wrapper">
        <div className="layout-topbar-left">
          {show_customers && (
            <button tabIndex={0} className="p-link" onClick={goToHome}>
              <img
                src={client_info.logo}
                alt={client_info.name}
                className="img-logo"
                loading="lazy"
              />
            </button>
          )}
          {!show_customers && (
            <img
              loading="lazy"
              src={client_info.logo}
              alt={client_info.name}
              className="img-logo"
            />
          )}
          {current_customer && (
            <h6 onClick={gotoMain} className={`${client_name_css}`}>
              {current_customer.name}{" "}
            </h6>
          )}
        </div>

        {!current_customer ? (
          <div className="layout-topbar-right ">
            <ul className="layout-topbar-actions">
              <li className={classNames("topbar-item")}>
                <button
                  onClick={showFeedback}
                  className="p-link cursor-pointer "
                  tabIndex={0}
                >
                  <i className="pi pi-comments text-xl  pt-1 pr-1"></i>
                </button>

                <LanguageFlag
                  onSetLanguage={setLanguage}
                  currentLang={currentlang}
                ></LanguageFlag>

                <button
                  onClick={logout}
                  className="p-link"
                  tabIndex={0}
                  style={{
                    cursor: "pointer",
                    padding: "0px",
                    margin: "0px 4px",
                  }}
                >
                  <i
                    aria-label="logout"
                    className="topbar-icon pi pi-power-off"
                  ></i>
                </button>
              </li>
            </ul>
          </div>
        ) : (
          <div className="flex align-items-center justify-content-end h-full w-full">
            <LanguageFlag
              onSetLanguage={setLanguage}
              currentLang={currentlang}
            ></LanguageFlag>

            <SplitButton
              className="ml-3"
              icon="pi pi-power-off"
              onClick={logout}
              model={items}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AppTopbar;
